import React, { useState, useEffect, useRef } from "react";
import ApplicationLayout from "../../../../layouts/ApplicationLayout";
import { Helmet } from "react-helmet";
import { PeriodSelectionWithCustom } from "../../../../components/TapUi";
import TapSelect from "../../../../components/ui/TapSelect";
import TapIcon from "../../../../services/TapIcon";
import { useSelector } from "react-redux";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

function TrackFuelValue() {
    const mapRef = useRef(null);
    const mapInstance = useRef(null);
    const markerRef = useRef(null);

    const assetList = [
        {
            id: 1,
            name: "Truck - DL01AB1234",
            lat: 28.6139,
            lng: 77.2090,
            status: "Running",
            time: "10:45 AM"
        },
        {
            id: 2,
            name: "Car - HR26XY9876",
            lat: 28.5355,
            lng: 77.3910,
            status: "Idle",
            time: "10:30 AM"
        },
        {
            id: 3,
            name: "Bike - DL05AA2222",
            lat: 28.4595,
            lng: 77.0266,
            status: "Stopped",
            time: "09:55 AM"
        }
    ];
    const [selectedReport, setSelectedReport] = useState(null);
    const [selectedAsset, setSelectedAsset] = useState(assetList[0]);

    const [formData, setFormData] = useState({
        date_range: "",
        date_range_start: null,
        date_range_end: null,
    });

    const [selectedAssets, setSelectedAssets] = useState([]);

    const toggleAsset = (assetId) => {
        setSelectedAssets((prev) =>
            prev.includes(assetId)
                ? prev.filter((id) => id !== assetId)
                : [...prev, assetId]
        );
    };
    useEffect(() => {
        if (!mapRef.current || mapInstance.current) return;

        mapInstance.current = L.map(mapRef.current).setView(
            [selectedAsset.lat, selectedAsset.lng],
            12
        );

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 19,
        }).addTo(mapInstance.current);

    }, []);
    useEffect(() => {
        if (!mapInstance.current || !selectedAsset) return;

        // remove old marker
        if (markerRef.current) {
            mapInstance.current.removeLayer(markerRef.current);
        }

        // add new marker
        markerRef.current = L.marker([
            selectedAsset.lat,
            selectedAsset.lng
        ]).addTo(mapInstance.current);

        // move map
        mapInstance.current.setView(
            [selectedAsset.lat, selectedAsset.lng],
            14,
            { animate: true }
        );

    }, [selectedAsset]);
    
  return (
    <div
        style={{
            background: "white",
            padding: "15px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            height: "80vh",
            display: "flex",
            flexDirection: "column",
        }}
    >
        <div
            style={{
                height: "50%",
                background: "#f4f6f8",
                borderRadius: "6px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "500",
            }}
        >
            <div
                ref={mapRef}
                style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "6px"
                }}
            />
        </div>
        <div
            className="mt-3"
            style={{
                flex: 1,
                overflowY: "auto",
                border: "1px solid #eee",
                borderRadius: "6px",
                padding: "10px",
            }}
        >
            <h6>Listing</h6>

            <table className="table table-sm">
                <thead>
                    <tr>
                        <th>Asset</th>
                        <th>Status</th>
                        <th>Location</th>
                        <th>Time</th>
                        <th>View</th>
                    </tr>
                </thead>

                <tbody>
                    {assetList.map((asset) => (
                        <tr
                            key={asset.id}
                            style={{
                                background:
                                    selectedAsset?.id === asset.id
                                        ? "#eef6ff"
                                        : "transparent"
                            }}
                        >
                            <td>{asset.name}</td>
                            <td>{asset.status}</td>
                            <td>
                                {asset.lat}, {asset.lng}
                            </td>
                            <td>{asset.time}</td>

                            <td>
                                <TapIcon.FontAwesomeIcon
                                    icon={TapIcon.faEye}
                                    style={{
                                        cursor: "pointer",
                                        color: "#0d6efd"
                                    }}
                                    onClick={() => setSelectedAsset(asset)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
  )
}

export default TrackFuelValue